import { Link, useLocation, useNavigate } from "react-router-dom";
import { AlertCircle, ArrowLeft, RefreshCw, Home } from "lucide-react";
import { Logo } from "@/components/Logo";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/lib/auth";
import { getHomeRouteByRole } from "@/lib/api";

export default function NotFound() {
  const location = useLocation();
  const navigate = useNavigate();
  const { user } = useAuth();

  const goHome = () => {
    if (user) {
      navigate(getHomeRouteByRole(user.role), { replace: true });
    } else {
      navigate("/login", { replace: true });
    }
  };

  const forceReset = () => {
    try {
      localStorage.clear();
      sessionStorage.clear();
    } catch {}
    window.location.href = `${window.location.origin}/login?reset=${Date.now()}`;
  };

  return (
    <div className="min-h-screen bg-paper flex items-center justify-center px-4 py-12">
      <div className="max-w-lg w-full">
        <div className="flex justify-center mb-8">
          <Logo height={64} />
        </div>

        <div className="bg-white border border-slate-200 rounded-2xl p-8 card-soft text-center">
          <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-amber-50 text-amber-700 mb-4">
            <AlertCircle className="w-7 h-7" />
          </div>
          <div className="text-xs uppercase tracking-wider text-slate-500 mb-2">Erro 404</div>
          <h1 className="serif text-3xl font-semibold text-slate-900">
            Página não encontrada
          </h1>
          <p className="mt-3 text-sm text-slate-600">
            A página <code className="px-1.5 py-0.5 bg-slate-100 rounded text-xs">{location.pathname}</code> não existe ou foi movida.
          </p>

          <div className="mt-6 flex flex-col sm:flex-row gap-2 justify-center">
            <Button onClick={goHome} className="bg-midnight hover:bg-ink text-white" data-testid="goto-home-button">
              <Home className="w-4 h-4 mr-2" />
              {user ? "Ir para o meu painel" : "Ir para o login"}
            </Button>
            <Button onClick={() => navigate(-1)} variant="outline" data-testid="goto-back-button">
              <ArrowLeft className="w-4 h-4 mr-2" />
              Voltar
            </Button>
          </div>

          <div className="mt-6 pt-6 border-t border-slate-200">
            <p className="text-xs text-slate-500 mb-2">
              Está tendo problemas de cache? Limpe a sessão e recomece:
            </p>
            <button
              onClick={forceReset}
              className="inline-flex items-center gap-2 text-xs font-medium px-3 py-1.5 rounded-md border border-slate-300 text-slate-700 hover:bg-slate-100"
              data-testid="not-found-reset-button"
            >
              <RefreshCw className="w-3.5 h-3.5" /> Limpar cache e recarregar
            </button>
          </div>
        </div>

        <div className="mt-6 text-center text-xs text-slate-500">
          CEAP Brasil &amp; Lopes &middot; Gestão de Contratos
        </div>
      </div>
    </div>
  );
}
